<template>

  <div id="coaching">

    <div class="c-img-bg c-academy-bg">

      <div class="container-xl">
        <div class="row">
          <div class="col-12">

            <!-- navigation-->
            <Navi dark-mode></Navi>

            <!-- coaching -->  
            <div class="row justify-content-center">
              <div class="col-11 coll-md-10">                    
                <div class="row">
                  <div class="col-12 order-1 col-md-7 order-md-1 py-3 align-self-start">
                    <h1 class="c-h1">Coachings</h1>  
                    <p class="c-txt-orange" style="font-weight: bold;">Neue Wege in Begleitung gehen</p>      
                  </div>
                  <div class="col-12 order-2 col-md-2 order-md-2 align-self-center">
                    <img id="kn_top_coaches" src="@/assets/top_coaches_badge.png" alt="HappinessAndWork_TopCoaches_Badge">
                    <!--
                    <a  href="https://derarthur.de/top-coaches-10-22-online-advertorial-webseite-manager-magazin/" target="_blank">
                      <img id="kn_top_coaches" src="@/assets/top_coaches_badge.png" alt="HappinessAndWork_TopCoaches_Badge">
                    </a>
                    -->
                  </div>
                  <div class="col-12 order-1 py-3 col-md-8 order-md-2 d-flex align-items-center justify-content-center">             
                    <p class="text-center text-md-left">
                        Coaching ist der Beschleuniger für persönliche Entwicklung überhaupt. 
                        Wir arbeiten mit einem systemischen Ansatz und kombinieren mit positiver Psychologie.
                        Unser Fokus bist ganz klar Du als Mensch. Wir schauen nicht auf Defizite, sondern auf Stärken, 
                        Sinnempfinden und Ressourcen. Ob im Einzelgespräch, 
                        im Team oder mit dem PERMA-Lead-Profiler - Coaching öffnet Türen, wo vorher Grenzen waren.
                    </p>
                    <img id="bubble_academy_1" src="@/assets/bubble_red_1.png" alt="bubble">  
                  </div>
                  <div class="col-12 order-2 py-3 col-md-4 order-md-3 d-flex justify-content-end">             
                  </div>
                </div>    
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- wave bottom -->
      <div class="c-wave c-wave-bottom"/>
    </div>

    <!-- course overview -->
    <div class="container-xl">
      <!-- 1-3 -->
      <div class="row justify-content-center">
        <div class="col-11 col-md-10 pb-5">   
          <div class="row align-items-end">
            <!-- individual coaching -->
            <div class="col-12 order-1 col-md-4 order-md-4">
              <img src="@/assets/coaching_1-sm.png" alt="Individual_coaching" style="margin: 20px; width: 80%; max-width: 280px;">
            </div>
            <div class="col-12 order-2 col-md-4 order-md-1">
              <h2 class="c-h2 c-txt-yellow">Systemisches Einzelcoaching für Führungskräfte & CEOs</h2>
            </div>
            <div class="col-12 order-3 col-md-4 order-md-7 align-self-start text-left">
              <p>
                Im Einzelcoaching arbeiten wir fokussiert an dem, 
                was dich gerade bewegt: Entscheidungen, Rollen, Konflikte, Selbstführung. 
              </p>
            </div> 
            <div class="col-12 order-4 col-md-4 order-md-10">
              <div class="d-flex justify-content-center">  
                <!-- button -->
                <router-link to="coaching/individual_coaching" style="text-decoration: none">
                  <div class="c-btn c-btn-orange" >
                    <span style="padding: 5px">Mehr Infos</span>
                    <div class="c-btn-img c-btn-img-right-white"/>
                  </div>
                </router-link>
              </div>
            </div>
            <!-- team coaching -->
            <div class="col-12 order-5 col-md-4 order-md-5">
              <img src="@/assets/coaching_2-sm.png" alt="Team_coaching" style="margin: 20px; width: 85%;  max-width: 280px;">
            </div>  
            <div class="col-12 order-6 col-md-4 order-md-2">
              <h2 class="c-h2 c-txt-blue">Team-Coaching</h2>
            </div>
            <div class="col-12 order-7 col-md-4 order-md-8 align-self-start text-left">
              <p>
                In Teams geht es vor allem um Besprechbarkeit und Kommunikationsqualität 
                - auch und gerade in Belastungssituationen. 
              </p>
            </div>
            <div class="col-12 order-8 col-md-4 order-md-11">
              <div class="d-flex justify-content-center">  
                <!-- button -->
                <router-link to="/coaching/team_coaching" style="text-decoration: none">
                  <div class="c-btn c-btn-orange">
                    <span style="padding: 5px">Mehr Infos</span>
                    <div class="c-btn-img c-btn-img-right-white"/>
                  </div>
                </router-link>
              </div>
            </div>            
            <!-- perma lead coaching -->
            <div class="col-12 order-9 col-md-4 order-md-6">
              <img src="@/assets/coaching_3-sm.png" alt="Perma_lead_profiles_coaching" style="margin: 20px; width: 85%; max-width: 280px;">
            </div>
            <div class="col-12 order-10 col-md-4 order-md-3">
              <h2 class="c-h2 c-txt-orange">Coaching mit dem PERMA-Lead-Profiler</h2>
            </div>            
            <div class="col-12 order-11 col-md-4 order-md-9 align-self-start text-left">
              <p>
                Der PERMA-Lead-Profiler ist ein wissenschaftlich fundiertes Tool, das in wenigen Minuten zeigt, 
                wie stark eine Führungskraft in den fünf Säulen von PERMA aufgestellt ist. 
              </p>
            </div>
            <div class="col-12 order-12 col-md-4 order-md-12">
              <div class="d-flex justify-content-center">  
                <!-- button -->
                <router-link to="/coaching/perma_lead_coaching" style="text-decoration: none">
                  <div class="c-btn c-btn-orange" >
                    <span style="padding: 5px">Mehr Infos</span>
                    <div class="c-btn-img c-btn-img-right-white"/>
                  </div>
                </router-link>
              </div>
            </div>  
          </div>
        </div>
      </div>
    </div>

    <!-- footer -->
    <div class="c-orange-bg">   
      <!-- wave top -->
      <div class="c-wave c-wave-top" style="position: relative; top:-2px;"/>
      <!-- footer content -->
      <div class="container-xl">
        <div class="row c-txt-white c-footer">
          <div class="col-12">
            <Footer></Footer>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Navi from '@/components/Navi.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Coaching',
  components: {
    Navi,
    Footer
  },
  metaInfo() {
    // patch meta data on current page
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: `${this.metaTitle}`,
      meta: [
        { vmid: "keywords",  name: 'keywords', content: `${this.metaKeywords}` },
        { vmid: "description", name: 'description', content: `${this.metaDescription}`},
        // social tagging
        { vmid: "og:title", property: "og:title", content: `${this.metaTitle}` },
        { vmid: "og:url", property: "og:url", content: `${this.metaUrl}` },
        { vmid: "og:description", property: "og:description", content: `${this.metaDescription}` },
        { vmid: "og:image", name: 'og:image', content: `${this.metaImage}` }
      ]
    }
  },
  data() {
    return {
      // metaData
      metaTitle: "- Academy - Wie schafft es eine Organisation, dass ihre Mitarbeiter glücklich sind?",
      metaDescription: "Wie schafft es eine Organisation, dass ihre Mitarbeiter glücklich sind? Die Felicicon GmbH hat Weiterbildungsangebote für Mitarbeiter und Führungskräfte und führen in Mitarbeiter Events in das Thema ein.",
      metaUrl: "/academy",
      metaKeywords: "Seminar Beratung Coaching Teamentwicklung Keynotes 'Happinessandwork Academy'",
      metaImage: "https://www.happinessandwork.de/share/academy.png"
    }
  },
  // called when component is mounted to the dom
  mounted: function () {
    // Create render evnt puppeteer is waiting for when prerender pager (see param: renderAfterDocumentEvent)
    document.dispatchEvent(new Event('render-event'))
  },
  methods: {
  }
}

</script>

<style>
</style>
